export const hasPromoCode = (state) => !!state.promoCode;
export const getPromoCode = (state) => state.promoCode;
